// _PRAIP_ESKF stands for Predicted Risk Assuming Invasive Procedure - End Stage Kidney Failure

/* eslint-disable camelcase */
// noinspection UnnecessaryLocalVariableJS

import {HEALTH_FACTORS} from '../../../containers/appConstants';
import {COEFFICIENTS, BASELINES} from './eqConstants';

export const _PRAIP_ESKF = patientHealthFactors => {
  const age = patientHealthFactors.age;
  const sex = patientHealthFactors.sex === HEALTH_FACTORS.MALE ? 1 : 0;
  const eGFR = patientHealthFactors.egfr;
  const haemoglobin = patientHealthFactors.hemoglobin;
  const albuminuria_mild = patientHealthFactors.albuminuria === HEALTH_FACTORS.MILD ? 1 : 0;
  const albuminuria_heavy = patientHealthFactors.albuminuria === HEALTH_FACTORS.HEAVY ? 1 : 0;
  const prior_invasive = patientHealthFactors.clinicalHistory.includes(HEALTH_FACTORS.PRIOR_CARDIAC_CATHETERIZATION) ? 1 : 0;

  const S0 = 0.9997;

  const EBX = 0.4674 +
    COEFFICIENTS.age * (age + BASELINES.age) +
    COEFFICIENTS.sex * sex +
    COEFFICIENTS.eGFR * (eGFR + BASELINES.eGFR) +
    COEFFICIENTS.hemo * (haemoglobin + BASELINES.hemo) +
    COEFFICIENTS.albuminuriaMild * albuminuria_mild +
    COEFFICIENTS.albuminuriaHEavy * albuminuria_heavy +
    COEFFICIENTS.priorInv * prior_invasive;

  const predictedRiskInvasive = 1 - Math.pow(S0, Math.pow(Math.exp(Math.abs(EBX)), Math.sign(EBX)));

  const endStageKidneyFailure = {
    PRI: predictedRiskInvasive,
    probability: predictedRiskInvasive * 100,
    age: age,
    sex: sex,
    eGFR: eGFR,
    haemoglobin: haemoglobin,
    albuminuria_mild: albuminuria_mild,
    albuminuria_heavy: albuminuria_heavy,
    prior_invasive: prior_invasive,
    S0: S0,
    EBX: EBX

  };

  return endStageKidneyFailure;
};
